"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentModelApprovalStatusEnum = exports.AttachmentModelStateEnum = exports.AttachmentModelPurposesEnum = exports.AttachmentModelToJSON = exports.AttachmentModelFromJSONTyped = exports.AttachmentModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentModelFromJSON(json) {
    return AttachmentModelFromJSONTyped(json, false);
}
exports.AttachmentModelFromJSON = AttachmentModelFromJSON;
function AttachmentModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': !runtime_1.exists(json, 'type') ? undefined : json['type'],
        'purposes': json['purposes'],
        'state': json['state'],
        'created': (new Date(json['created'])),
        'fields': !runtime_1.exists(json, 'fields') ? undefined : (json['fields'].map(_1.AttachmentFieldFromJSON)),
        'items': !runtime_1.exists(json, 'items') ? undefined : (json['items'].map(_1.AttachmentItemModelFromJSON)),
        'enrollmentStateAtUploadTime': !runtime_1.exists(json, 'enrollmentStateAtUploadTime') ? undefined : _1.EnrollmentStateFromJSON(json['enrollmentStateAtUploadTime']),
        'documentReviewNotes': !runtime_1.exists(json, 'documentReviewNotes') ? undefined : json['documentReviewNotes'],
        'otherReviewNotes': !runtime_1.exists(json, 'otherReviewNotes') ? undefined : json['otherReviewNotes'],
        'approvalStatus': !runtime_1.exists(json, 'approvalStatus') ? undefined : json['approvalStatus'],
        'sealLocation': !runtime_1.exists(json, 'sealLocation') ? undefined : _1.SealLocationEnumFromJSON(json['sealLocation']),
        'signatureLocation': !runtime_1.exists(json, 'signatureLocation') ? undefined : _1.SignatureLocationEnumFromJSON(json['signatureLocation']),
    };
}
exports.AttachmentModelFromJSONTyped = AttachmentModelFromJSONTyped;
function AttachmentModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'purposes': value.purposes,
        'state': value.state,
        'created': (value.created.toISOString()),
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.AttachmentFieldToJSON)),
        'items': value.items === undefined ? undefined : (value.items.map(_1.AttachmentItemModelToJSON)),
        'enrollmentStateAtUploadTime': _1.EnrollmentStateToJSON(value.enrollmentStateAtUploadTime),
        'documentReviewNotes': value.documentReviewNotes,
        'otherReviewNotes': value.otherReviewNotes,
        'approvalStatus': value.approvalStatus,
        'sealLocation': _1.SealLocationEnumToJSON(value.sealLocation),
        'signatureLocation': _1.SignatureLocationEnumToJSON(value.signatureLocation),
    };
}
exports.AttachmentModelToJSON = AttachmentModelToJSON;
/**
* @export
* @enum {string}
*/
var AttachmentModelPurposesEnum;
(function (AttachmentModelPurposesEnum) {
    AttachmentModelPurposesEnum["FACIALIDENTIFICATION"] = "FACIAL_IDENTIFICATION";
    AttachmentModelPurposesEnum["FINGERPRINTIDENTIFICATION"] = "FINGERPRINT_IDENTIFICATION";
    AttachmentModelPurposesEnum["CITIZENSHIP"] = "CITIZENSHIP";
    AttachmentModelPurposesEnum["NAMELINKING"] = "NAME_LINKING";
    AttachmentModelPurposesEnum["PHOTOID"] = "PHOTO_ID";
})(AttachmentModelPurposesEnum = exports.AttachmentModelPurposesEnum || (exports.AttachmentModelPurposesEnum = {}));
/**
* @export
* @enum {string}
*/
var AttachmentModelStateEnum;
(function (AttachmentModelStateEnum) {
    AttachmentModelStateEnum["VALID"] = "VALID";
    AttachmentModelStateEnum["INVALID"] = "INVALID";
})(AttachmentModelStateEnum = exports.AttachmentModelStateEnum || (exports.AttachmentModelStateEnum = {}));
/**
* @export
* @enum {string}
*/
var AttachmentModelApprovalStatusEnum;
(function (AttachmentModelApprovalStatusEnum) {
    AttachmentModelApprovalStatusEnum["PREAPPROVED"] = "PRE_APPROVED";
    AttachmentModelApprovalStatusEnum["APPROVED"] = "APPROVED";
    AttachmentModelApprovalStatusEnum["PENDING"] = "PENDING";
    AttachmentModelApprovalStatusEnum["REJECTED"] = "REJECTED";
    AttachmentModelApprovalStatusEnum["NOTREQUIRED"] = "NOT_REQUIRED";
    AttachmentModelApprovalStatusEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(AttachmentModelApprovalStatusEnum = exports.AttachmentModelApprovalStatusEnum || (exports.AttachmentModelApprovalStatusEnum = {}));
//# sourceMappingURL=AttachmentModel.js.map